import { useEffect, useState } from 'react';

const RenderPDFDocument = ({ fileBuffer }) => {
  const [url, setUrl] = useState(null);

  useEffect(() => {
    if (!fileBuffer) {
      setUrl(null);
      return undefined;
    }

    const objectUrl = URL.createObjectURL(new Blob([fileBuffer], { type: 'application/pdf' }));
    setUrl(objectUrl);

    return () => {
      URL.revokeObjectURL(objectUrl);
    };
  }, [fileBuffer]);

  if (!url) return null;

  return <iframe src={url} style={{ width: '100%', height: '100%', border: 'none' }} title="PDF viewer" />;
};

export default RenderPDFDocument;
